import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    focusable: false,
};
export function CheckGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M3.5 8.5l3 3 6-7" }) }));
}
export function DashGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M4 8h8" }) }));
}
export function ChevronDownGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M4 6l4 4 4-4" }) }));
}
export function ChevronRightGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M6 4l4 4-4 4" }) }));
}
export function CloseGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M4 4l8 8M12 4l-8 8" }) }));
}
export function DotGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("circle", { cx: "8", cy: "8", r: "2.5", fill: "currentColor", stroke: "none" }) }));
}
export function InfoGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25" }), _jsx("path", { d: "M8 7.25v3.5M8 5.25h.01" })] }));
}
export function WarningGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M8 2.25l6.25 11H1.75z" }), _jsx("path", { d: "M8 6.5v3M8 11.25h.01" })] }));
}
export function SuccessGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25" }), _jsx("path", { d: "M5.5 8.25l1.75 1.75 3.25-3.75" })] }));
}
export function CopyGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("rect", { x: "5.25", y: "5.25", width: "8", height: "8", rx: "1.5" }), _jsx("path", { d: "M10.75 5.25V3.75a1.5 1.5 0 0 0-1.5-1.5h-5.5a1.5 1.5 0 0 0-1.5 1.5v5.5a1.5 1.5 0 0 0 1.5 1.5h1.5" })] }));
}
export function EyeGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M1.75 8s2.25-4.5 6.25-4.5S14.25 8 14.25 8 12 12.5 8 12.5 1.75 8 1.75 8z" }), _jsx("circle", { cx: "8", cy: "8", r: "1.75" })] }));
}
export function EyeOffGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M6.6 3.65A6 6 0 0 1 8 3.5c4 0 6.25 4.5 6.25 4.5a11 11 0 0 1-1.6 2.2M9.4 9.4a1.75 1.75 0 0 1-2.8-2.05M4.2 4.95A10.6 10.6 0 0 0 1.75 8S4 12.5 8 12.5a5.9 5.9 0 0 0 3.05-.85" }), _jsx("path", { d: "M2 2l12 12" })] }));
}
export function ErrorGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25" }), _jsx("path", { d: "M6 6l4 4M10 6l-4 4" })] }));
}
/** A half-filled circle: "partly working". */
export function PartialGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25" }), _jsx("path", { d: "M8 1.75a6.25 6.25 0 0 1 0 12.5z", fill: "currentColor" })] }));
}
export function WrenchGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M9.9 2.4a3.25 3.25 0 0 0-3.6 4.4L2.4 10.7a1.4 1.4 0 0 0 2 2l3.9-3.9a3.25 3.25 0 0 0 4.4-3.6l-2 2-1.9-.5-.5-1.9z" }) }));
}
export function HelpGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25", strokeDasharray: "2.2 1.8" }), _jsx("path", { d: "M6.4 6.3a1.65 1.65 0 0 1 3.2.55c0 1.1-1.6 1.4-1.6 2.4M8 11.25h.01" })] }));
}
export function LockGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("rect", { x: "3.25", y: "7", width: "9.5", height: "6.75", rx: "1.5" }), _jsx("path", { d: "M5.5 7V5a2.5 2.5 0 0 1 5 0v2" })] }));
}
export function OfflineGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M2 2l12 12" }), _jsx("path", { d: "M1.75 6.25a9 9 0 0 1 3-1.9M7.5 4a9 9 0 0 1 6.75 2.25M4 8.75a5.5 5.5 0 0 1 2.4-1.3M10.6 8a5.5 5.5 0 0 1 1.4.75M6.25 11.25a2.5 2.5 0 0 1 3.5 0" })] }));
}
export function SearchGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "7", cy: "7", r: "4.5" }), _jsx("path", { d: "M10.5 10.5l3 3" })] }));
}
export function RetryGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M13.25 8a5.25 5.25 0 1 1-1.54-3.71" }), _jsx("path", { d: "M13.25 2.75v3h-3" })] }));
}
export function PencilGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M10.5 3.5l2 2M3 13l.5-2.5 7.25-7.25a1.4 1.4 0 0 1 2 2L5.5 12.5 3 13z" }) }));
}
export function MenuGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M2.75 4.5h10.5M2.75 8h10.5M2.75 11.5h10.5" }) }));
}
export function CalendarGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("rect", { x: "2.25", y: "3.25", width: "11.5", height: "10.5", rx: "1.75" }), _jsx("path", { d: "M2.25 6.75h11.5M5.5 1.75v3M10.5 1.75v3" })] }));
}
export function ClockGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.25" }), _jsx("path", { d: "M8 4.75V8l2.25 1.5" })] }));
}
// Wave 4 data glyphs (DataTable, FilterBar, BulkActionBar, SavedViews).
export function MoreGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("circle", { cx: "3.5", cy: "8", r: "1.1", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "8", cy: "8", r: "1.1", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "12.5", cy: "8", r: "1.1", fill: "currentColor", stroke: "none" })] }));
}
export function ColumnsGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("rect", { x: "2.5", y: "3", width: "11", height: "10", rx: "1.5" }), _jsx("path", { d: "M6.25 3v10M9.75 3v10" })] }));
}
export function FilterGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M2.5 4h11M4.75 8h6.5M7 12h2" }) }));
}
export function PlusGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M8 3.5v9M3.5 8h9" }) }));
}
export function StarGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M8 2.5l1.7 3.45 3.8.55-2.75 2.68.65 3.78L8 11.18l-3.4 1.78.65-3.78L2.5 6.5l3.8-.55L8 2.5z" }) }));
}
// Collaboration (wave 6 group A): NotificationCenter, MessageTimeline.
export function BellGlyph(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M4 6.5a4 4 0 0 1 8 0c0 3.5 1.5 4.75 1.5 4.75h-11S4 10 4 6.5z" }), _jsx("path", { d: "M6.75 13.5a1.4 1.4 0 0 0 2.5 0" })] }));
}
export function ArrowDownGlyph(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M8 3v10M4 9l4 4 4-4" }) }));
}
//# sourceMappingURL=icons.js.map